// LLM generated - Model Claude Opus 4
/**
 * Chat panel dimension constants
 * Used for layout calculations when the chat side panel is open
 */

export const CHAT_PANEL_WIDTH = 393;

export const CHAT_PANEL_GAP = 24;

export const CHAT_PANEL_RIGHT_PADDING = 60;

export const CHAT_PANEL_TOTAL_WIDTH = CHAT_PANEL_WIDTH + CHAT_PANEL_GAP;

export const CHAT_PANEL_ANIMATION_DURATION = 300;

export const CHAT_PANEL_TOP_PADDING = 16;

export const CHAT_PANEL_BOTTOM_PADDING = 16;

export const CHAT_PANEL_MIN_HEIGHT = 400;
